/*
Libraries and call to js functions
*/

// Import jQuery
global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

import bootstrap from 'bootstrap';

import mainFunctions from './js/main-functions';

$(function() {
	lightbox.option({
		showImageNumberLabel: false,
		disableScrolling: true,
		albumLabel: false,
		wrapAround: false,
		positionFromTop: 0
	});
});

//blocks
import './blocks/courses-carousel/index';
import './blocks/events-carousel/index';
import './blocks/location-schedule/index';
import './blocks/available-programs/index';
import './blocks/multi-content/index';
import './blocks/interactive-map/index';
import './blocks/prueba/index';
import './blocks/full-hero/index';
import './blocks/list-gallery/index';

//Components
import './components/gototop/index';
import './components/menucomponent/index';
import './components/slider-desktop-courses-info/index';
import './components/slider-mobile-courses-info/index';
import './components/mision-vision/index';
import './components/slider-tablet-courses-info/index';
import './components/accordion/index';
import './components/image-gallery/index';
import './components/image-gallery-slider/index';
import './components/park-data/index';
import './components/completed-projects/index';
import './components/carousel/index';
import './components/courses-slider/index';

/**
 * pages
 **/
import './pages/templates/available-courses/index';
import './pages/templates/forms/index';
